import {Component} from '@angular/core';
import {Autowired} from '@angular-ru/autowired';
import {AtlantisComboComponent} from '@shared/behaviors/atlantis-extend-clv/atlantis-combo.component';
import { SelectGarantMetierService } from './select-garant.metier.service';

@Component({
  selector: 'app-select-garant',
  template: `
    <app-atlantis-combo [label]="label"
                        [options]="options$ | async"
                        [required]="required"
                        [control]="control"
                        [placeholder]="placeholder"
                        [actionColor]="actionColor"
                        [actionIcon]="actionIcon"
                        (onChange)="onChange?.emit($event)"
                        (onBlur)="onBlur?.emit($event)"
                        (onClick)="onClick?.emit($event)"
                        (onFocus)="onFocus?.emit($event)"
                        (onShow)="onShow?.emit($event)"
                        (onHide)="onHide?.emit($event)"
                        (actionDeclenche)="actionDeclenche.emit($event)">
    </app-atlantis-combo>
  `
})
export class SelectGarantComponent extends AtlantisComboComponent {
  @Autowired() recupererOptionsMetier: SelectGarantMetierService;

  constructor() {
    super();
    this.label = 'Evenement';
    this.hasAction = true;
  }
}
